import { WorkModeType } from './../models/camera.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { AlertMsgMngrService } from './alert-msg-mngr.service';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { VideoMsgMngrService } from './video-mngr.service';

@Injectable({
  providedIn: 'root'
})

export class AnalyticsMngrService {
  constructor(private http: HttpClient, private alertmngr: AlertMsgMngrService, private msgboxsvc: MsgBoxService, private vidmngr: VideoMsgMngrService) { }

  sendAnalticsRequest(streamName: string, res: string, onoff: boolean, workMode: WorkModeType = WorkModeType.FULL) {
    let token: string = this.alertmngr.getToken();
    if (AppConfig.settings.analysisAddress.useToken && token == undefined) {
      this.msgboxsvc.showErrorMsg("Cannot Send analysis without token!!! please re-Login...");
    }
    const headers = new HttpHeaders({
      'Connect-Type': 'application/json',
    });
    
    const payload = {
      StreamName: streamName,
      StreamURL: AppConfig.settings.analysisAddress.rtspTemplate + streamName,
      ForwardMessage: AppConfig.settings.analysisAddress.forwardAddress,
      Token: token,
      Resolution: res,
      WorkMode: WorkModeType[workMode]
    };

    let bind: string = "";
    if (onoff)
      bind = "start";
    else
      bind = "stop";

    this.http.post<any>(AppConfig.settings.analysisAddress.address + bind, payload, { headers }).subscribe(
      response => console.log('Success:', response),
      error => console.error('Error:', error)
    );
    
  }
}
